var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2390_10835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0176 18.3804C19.1953 18.5582 19.1937 18.8474 19.0127 19.023C18.8298 19.2003 18.5435 19.1807 18.373 19.0103L4.98242 5.61969C4.89453 5.53179 4.84972 5.41631 4.84961 5.30133C4.84961 5.16642 4.91079 5.03047 5.03027 4.94C5.21591 4.79969 5.4709 4.83375 5.62598 4.98883L19.0176 18.3804Z",
    fill: "#474747",
    stroke: "#474747",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1504 18.699C19.1504 18.948 18.9482 19.1502 18.6992 19.1502L13.5898 19.1502C13.3409 19.1502 13.1387 18.948 13.1387 18.699C13.1388 18.4502 13.341 18.2488 13.5898 18.2488L18.248 18.2488V13.5897C18.248 13.3407 18.4503 13.1385 18.6992 13.1385C18.9482 13.1385 19.1504 13.3407 19.1504 13.5897V18.699Z",
    fill: "#474747",
    stroke: "#474747",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8615 5.30078C10.8615 5.54974 10.6593 5.75195 10.4103 5.75195L5.75116 5.75195V10.4102C5.75116 10.659 5.54983 10.8612 5.30096 10.8613C5.05202 10.8613 4.84979 10.6591 4.84979 10.4102V5.30078C4.84979 5.05183 5.05201 4.84961 5.30096 4.84961L10.4103 4.84961C10.6593 4.84961 10.8615 5.05183 10.8615 5.30078Z",
    fill: "#474747",
    stroke: "#474747",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2390_10835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(19 5) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.459a4490d7cc5f219a4d40ac12e94255.svg";
export { ForwardRef as ReactComponent };